import React, { useState, useCallback, useEffect } from 'react';
import IdleTimer from 'react-idle-timer';
import Snackbar from '@mui/material/Snackbar';
import { useHistory } from 'react-router-dom';

import Auth, { useUser } from 'shared/auth';

const idleUntilWarningSeconds = 55 * 60;
const warningTimeSeconds = 5 * 60;

const padLeft = sec => (sec > 9 ? '' : '0') + sec;
const getTimeString = sec => `${padLeft(Math.trunc(sec / 60))}:${padLeft(sec % 60)}`;

export default function Idle() {
  const user = useUser();
  const { push } = useHistory();
  const [isIdle, setIsIdle] = useState();
  const [secondsLeft, setSecondsLeft] = useState();
  const handleIdle = useCallback(() => {
    setIsIdle(true);
    setSecondsLeft(warningTimeSeconds);
  }, [setIsIdle]);
  const handleActive = useCallback(() => {
    setIsIdle(false);
  }, [setIsIdle]);
  useEffect(() => {
    if (!isIdle) {
      return;
    }

    const timeout = setTimeout(() => {
      window.signedOutIdle = true;
      setIsIdle(false);
      user.signInAs(null);
      Auth.signOut();
      push('/login');
    }, warningTimeSeconds * 1000);
    const interval = setInterval(() => {
      setSecondsLeft(sec => sec - 1);
    }, 1000);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [isIdle, setSecondsLeft, setIsIdle, user, push]);

  return (
    <>
      <IdleTimer
        onIdle={handleIdle}
        onActive={handleActive}
        timeout={idleUntilWarningSeconds * 1000}
    />
    <Snackbar
      open={isIdle}
      message={`Your session will end in ${getTimeString(secondsLeft)} minutes`}
    />
   </>
  );
}